import { render, staticRenderFns } from "./PersonalAccountOM.vue?vue&type=template&id=7253b3d6&scoped=true&"
import script from "./PersonalAccountOM.vue?vue&type=script&lang=js&"
export * from "./PersonalAccountOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7253b3d6",
  null
  
)

export default component.exports